import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { panelEnter, panelExit } from './keyframes';
const closeButtonSizeMap = {
    large: tokens.spacing.xsmall,
    medium: '6px',
};
const variantMap = {
    error: {
        color: theme.error.main,
    },
    info: {
        color: theme.info.main,
    },
    success: {
        color: theme.success.main,
    },
    upgrade: {
        color: theme.upgrade.main,
    },
    warning: {
        color: theme.warning.main,
    },
};
const panelStaticStyle = css({
    backgroundColor: theme.background.contrast,
    border: `${tokens.borderWidth.thin} solid ${theme.border.strong}`,
    borderRadius: tokens.borderRadius.medium,
    boxShadow: theme.boxShadow.thick,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    maxWidth: '600px',
    minHeight: '180px',
    minWidth: '100%',
    opacity: 0,
    outline: 0,
    pointerEvents: 'all',
    position: 'absolute',
    transform: 'translateY(12px)',
    zIndex: tokens.zIndex.modal,
    [mediaQuery.aboveSmall]: {
        minWidth: '400px',
    },
});
export function panelStyle({ alignCenter, isPositioned, isVisible, x, y, }) {
    return [
        panelStaticStyle,
        css({
            animation: `${isVisible ? panelEnter : panelExit} 200ms cubic-bezier(0.2, 0.8, 0.6, 1) forwards`,
        }),
        alignCenter &&
            css({
                textAlign: 'center',
            }),
        isPositioned
            ? css({
                left: x !== null && x !== void 0 ? x : 0,
                top: y !== null && y !== void 0 ? y : 0,
                width: 'max-content',
            })
            : css({
                inset: 'unset',
            }),
    ];
}
const closeButtonStaticStyle = css({
    position: 'absolute',
    zIndex: tokens.zIndex.default,
});
export function closeButtonStyle({ hasDecorativeHeader, size, }) {
    const spacing = closeButtonSizeMap[size];
    return [
        closeButtonStaticStyle,
        css({
            color: hasDecorativeHeader ? theme.navy.textOnColor : theme.text.main,
            right: spacing,
            top: spacing,
        }),
    ];
}
// Required to position shadow scroll indicators at the top or bottom
export const bodyWrapperStaticStyle = css({
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    position: 'relative',
});
const bodyShadowsStaticStyle = css({
    inset: 0,
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: tokens.zIndex.default,
});
const bodyBothShadowsStaticStyle = css({
    boxShadow: `inset 0 12px 12px -12px ${theme.transparentGrey.main}, inset 0 -12px 12px -12px ${theme.transparentGrey.main}`,
});
export function bodyShadowsStyle({ isShadowBottomVisible, isShadowTopVisible, }) {
    const hasBothShadowsVisible = isShadowTopVisible && isShadowBottomVisible;
    return [
        bodyShadowsStaticStyle,
        hasBothShadowsVisible
            ? bodyBothShadowsStaticStyle
            : css({
                boxShadow: isShadowTopVisible
                    ? `inset 0 12px 12px -12px ${theme.transparentGrey.main}`
                    : `inset 0 -12px 12px -12px ${theme.transparentGrey.main}`,
            }),
    ];
}
export const bodyStaticStyle = css({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: tokens.spacing.small,
    paddingLeft: tokens.spacing.medium,
    paddingRight: tokens.spacing.medium,
    paddingTop: 0,
    width: '100%',
});
const avatarStaticStyle = css({
    alignItems: 'center',
    backgroundColor: theme.background.contrast,
    borderRadius: tokens.borderRadius.circle,
    boxShadow: theme.boxShadow.thick,
    display: 'flex',
    height: tokens.sizing.large,
    justifyContent: 'center',
    position: 'relative',
    top: '50%',
    width: tokens.sizing.large,
});
export function avatarStyle({ variant }) {
    return [
        avatarStaticStyle,
        css({
            color: variantMap[variant].color,
        }),
    ];
}
const decorativeHeaderStaticStyle = css({
    backgroundColor: theme.navy.lighter,
    borderTopLeftRadius: tokens.borderRadius.medium,
    borderTopRightRadius: tokens.borderRadius.medium,
    display: 'flex',
    height: '52px',
    justifyContent: 'center',
});
export function decorativeHeaderStyle({ variant }) {
    return [
        decorativeHeaderStaticStyle,
        css({
            borderBottom: `${tokens.borderRadius.medium} solid ${variantMap[variant].color}`,
        }),
    ];
}
const headerStaticStyle = css({
    flexShrink: 0,
    margin: 0,
    padding: `${tokens.spacing.medium} 48px ${tokens.spacing.medium}`,
});
export function headerStyle({ alignCenter }) {
    return [
        headerStaticStyle,
        css({
            paddingLeft: alignCenter ? '48px' : tokens.spacing.medium,
        }),
    ];
}
const footerStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: tokens.spacing.small,
    padding: tokens.spacing.medium,
    [mediaQuery.aboveSmall]: {
        flexDirection: 'row',
    },
});
export function footerStyle({ alignCenter }) {
    return [
        footerStaticStyle,
        css({
            justifyContent: alignCenter ? 'center' : 'end',
        }),
    ];
}
export const buttonStaticStyle = css({
    flexShrink: 1,
    width: '100%',
    [mediaQuery.aboveSmall]: {
        width: 'auto',
    },
});
